import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, withRouter } from "react-router-dom";

import Layout from "containers/Layout";
import { hasJWT, hasPagePermission } from "routes/utils";
import { ADMIN_CONFIG } from "routes/pageConfig";
import { track } from "../../utils/analytics";

const INTERNAL_ROLES = [
  "admin",
  "customer_support",
  "customer_support_readonly",
  "marketing",
];

const isInternalUser = (roles) => {
  return INTERNAL_ROLES.some((internalRole) => roles[internalRole]);
};

const InternalRoute = ({
  component: Component,
  roles,
  config = ADMIN_CONFIG,
  renderLayout = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!hasJWT()) {
        track("DASHBOARD_LOGIN_MISSING_JWT");
        return (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        );
      }
      // `isInternalUser()` is a safety check.
      // `pageConfig` should specify and `hasPagePermission()` handle access control for each page.
      if (!isInternalUser(roles) || !hasPagePermission(config)) {
        return (
          <Redirect
            to={{
              pathname: "/",
            }}
          />
        );
      }
      return (
        renderLayout ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Component {...props} />
        )
      );
    }}
  />
);

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default withRouter(connect(mapStateToProps)(InternalRoute));
